var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/Details/details.scss";
import SidebarBodyAccordion from "@frameworks/NCD/Components/SidebarBodyAccordion";
import Details from "./Details";
import { useProductDetails } from "@frameworks/NCD/Hook/DetailsSidebar/useProductDetails";
import { useAccordionProductDetails } from "@frameworks/NCD/Hook/DetailsSidebar/useAccordionProductDetails";
import { useSelector } from "react-redux";
import CustomIllustration from "@frameworks/shared-library/assets/images/features/Markets/NCD/product-illustration.svg";
var SidebarBodyDetails = function () {
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var containerRef = useRef(null);
    var contentRef = useRef(null);
    var _a = __read(useState(false), 2), showImage = _a[0], setShowImage = _a[1];
    var checkRemainingSpace = function () {
        var container = containerRef.current;
        var content = contentRef.current;
        if (!container || !content)
            return;
        var containerHeight = container.offsetHeight;
        var contentHeight = content.scrollHeight;
        var remainingSpace = containerHeight - contentHeight;
        setShowImage(remainingSpace >= 200);
    };
    useEffect(function () {
        checkRemainingSpace();
        // Recheck on window resize
        window.addEventListener("resize", checkRemainingSpace);
        return function () { return window.removeEventListener("resize", checkRemainingSpace); };
    }, [subCategoryId]); // Re-run if data changes
    return (React.createElement("div", { className: "aif-pms-sidebar-body otc-product-bouquet-wrapper" },
        React.createElement("div", { className: "custom-tabs-container h-100 pb-90" },
            React.createElement("div", { className: "position-relative w-100 h-100" },
                React.createElement("div", { className: "auto-height width-375 position-relative bg-white w-100 border-radius-8 overflow-x-hidden", style: { overflowX: "hidden" }, ref: containerRef },
                    React.createElement("div", { ref: contentRef },
                        React.createElement(Details, { details: useProductDetails(String(subCategoryId)) }),
                        React.createElement("div", { className: "accordion-details otc-accordion" },
                            React.createElement(SidebarBodyAccordion, { orderDetails: useAccordionProductDetails() })))),
                showImage && (React.createElement("img", { src: CustomIllustration, className: "position-absolute bottom-0 end-0", alt: "Product Illustration" }))))));
};
export default SidebarBodyDetails;
